import { AccuracySupplementalRowTypes } from "@app/exports/enumerations";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import { DropdownItem } from "@app/shared/checkbox-dropdown/types";
import { startCase } from "lodash";
import { Component } from "react";

type AccuracyRowTypeFilterProps = {
  onRowTypeChange: (recommendedAction: number) => void;
  onRowTypeChangeDropdown: (selections: DropdownItem<number>[]) => void;
  rowTypeIds: number[];
}

class WrappedAccuracyRowTypeFilter extends Component<AccuracyRowTypeFilterProps> {
  public render() {
    return (
      <>
        <p className="lead mb0 demibold">Row Type Filter</p>
        <p className="mb-1">Please select the row types to include:</p>
        {this.renderAccuracyRowTypes()}
      </>
    );
  }

  private renderAccuracyRowTypes() {
    const rowTypeItems: DropdownItem<number>[] = [];
    const selectedItems: DropdownItem<number>[] = [];
    let selectText = "";
    Object.values(AccuracySupplementalRowTypes).forEach((v, i) => {
      if (v !== AccuracySupplementalRowTypes.Unknown && v !== AccuracySupplementalRowTypes.Undefined) {
        const item = {
          key: i,
          name: startCase(v),
        };
      rowTypeItems.push(item)
      if (this.props.rowTypeIds.indexOf(i) > -1) {
        selectedItems.push(item);
      }
    }
  });
  selectText = `${selectedItems.length} of ${rowTypeItems.length} options selected`;

    return (
      <div className="form-group row" >
        <div className="col-12">
        <MultiselectDropdown
          label="Row Type Filter"
          hideLabel={true}
          containerClassName="w-100"
          customSelectInputText={selectText}
          items={rowTypeItems}
          selectedItems={selectedItems}
          testId="accuracy-row-type-filter__dropdown"
          onSelectionChanged={(selections) => this.props.onRowTypeChangeDropdown(selections)}
        />
        </div>
      </div>
    );
  }
}

export default WrappedAccuracyRowTypeFilter;
